'use strict';

var ids = require('./identifiers'),
    gettext = require('mag-gettext').gettext;

module.exports = [
    {
        id: ids.parentControl,
        name: gettext('Parent Control'),
        description: gettext('Parent Control'),
        icon: 'theme-icon-lock',
        parent: 'root'
    },
    {
        id: ids.userInterface,
        name: gettext('Interface'),
        description: gettext('System section general description'),
        icon: 'theme-icon-monitor',
        parent: ids.root
    }
];
